import { render } from "./MatchingRetrieval.vue?vue&type=template&id=5fd2c4c5&scoped=true&ts=true&lang=pug"
import script from "./MatchingRetrieval.vue?vue&type=script&lang=ts"
export * from "./MatchingRetrieval.vue?vue&type=script&lang=ts"

import "./MatchingRetrieval.vue?vue&type=style&index=0&id=5fd2c4c5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd2c4c5"]])

export default __exports__